import { STATUS_COLORS } from "@/lib/format";

export default function StatusBadge({ status, testid }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.Hidden;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
      style={{ color: c.text, background: c.bg, border: `1px solid ${c.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.text }} />
      {status}
    </span>
  );
}
